import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import axios from "axios";
import { useState } from "react";
import toast from "react-hot-toast";

function NewWorkTime({ open, triggerFetch, closeDialog }) {
  const theme = useTheme();
  const [time, setTime] = useState("");
  const [errors, setErrors] = useState({});

  const handleSubmit = async () => {
    // Reset errors
    const newErrors = {};

    // Validation checks
    if (!time.trim()) newErrors.time = "الوقت مطلوب.";
    // If there are errors, set them and prevent submission
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    const newTime = {
      duration: time,
    };
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/worktime`,
        newTime,
        {
          withCredentials: true,
        }
      );
      if (res) {
        closeDialog();
        triggerFetch();
        toast.success("تم إنشاء مدة العمل بنجاح");
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message ||
          "An error occurred while creating the method."
      );
    }
  };
  return (
    <Dialog
      open={open}
      PaperProps={{
        style: {
          borderRadius: "12px",
          minWidth: "300px"
        },
      }}
    >
      <Box sx={{ padding: "24px 24px 0" }}>
        <Typography variant="h5">إضافة مدة عمل جديدة</Typography>
      </Box>
      <DialogContent>
        <FormControl fullWidth sx={{ padding: "12px 0" }}>
          <TextField
            fullWidth
            label="المدة"
            value={time}
            onChange={(e) => setTime(e.target.value)}
            error={!!errors.time}
            helperText={errors.time}
          />
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => closeDialog()}
          variant="text"
          color={theme.palette.neutral[900]}
        >
          إغلاق
        </Button>
        <Button onClick={handleSubmit} variant="contained">
          إضافة
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default NewWorkTime;
